
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/Layout';
import { LanguageProvider } from './context/LanguageContext';

// Pages are imported statically (not React.lazy) so the prerendered HTML can be
// hydrated in place. With lazy chunks the initial hydration suspends and React
// replaces the server markup with the Suspense spinner, defeating the point.
import Home from './pages/Home';
import Services from './pages/Services';
import Methodology from './pages/Methodology';
import About from './pages/About';
import Disclaimer from './pages/Disclaimer';
import PrivacyStatement from './pages/PrivacyStatement';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/methodology" element={<Methodology />} />
            <Route path="/about" element={<About />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy-statement" element={<PrivacyStatement />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </LanguageProvider>
  );
};

export default App;
